export default function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-notifications/node_modules/dom-helpers/esm/hasClass.js
// module id = 426
// module chunks = 52